import React from 'react'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/modules/components/ui/carousel'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { PopularProgramCard } from '~widgets/popular-program-card/components/popular-program-card'

export const CarouselPrograms = ({
  popularPrograms
}: {
  popularPrograms: Awaited<ReturnType<typeof getPopularPrograms>>
}) => {
  return (
    <Carousel
      className='max-w-[1980px] mx-auto'
      aria-label='Popular programs'
      opts={{ align: 'center', startIndex: 1 }}>
      <CarouselContent>
        {popularPrograms?.map(el => (
          <CarouselItem
            key={el.slug}
            className='basis-full xl:basis-[30%] lg:basis-[40%] md:basis-1/2 sm:basis-[75%]  select-none pl-[8px] md:pl-[16px]'>
            <PopularProgramCard popularProgram={el} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className='flex gap-[16px] mx-auto w-fit mt-[30px] md:mt-[40px] xl:mt-[60px]'>
        <CarouselPrevious size='lg' />
        <CarouselNext size='lg' />
      </div>
    </Carousel>
  )
}
